// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__3lUNP","fluid":"Container_fluid__1JKtY"};